import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`network-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <Link to="/" className="network-logo-link">
          <img src="/vfit-logo.jpg" alt="V-Fit Training" className="network-logo-img" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="network-nav desktop-nav">
          <button onClick={() => scrollToSection('about')} className="network-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('services')} className="network-nav-link">
            Services
          </button>
          <button onClick={() => scrollToSection('results')} className="network-nav-link">
            Results
          </button>
          <button onClick={() => scrollToSection('contact')} className="network-nav-link">
            Contact
          </button>
          <Link to="/schedule" className="btn-nav-cta">
            Book Consultation
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('about')} className="mobile-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('services')} className="mobile-nav-link">
            Services
          </button>
          <button onClick={() => scrollToSection('results')} className="mobile-nav-link">
            Results
          </button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
            Contact
          </button>
          <Link to="/schedule" className="btn-primary mobile-cta">
            Book Consultation
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Navigation;
